import { Progress } from '@/legacy-src/components/ui/progress'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Text } from '@/src/domains/design-system/components/Text'

import { useSelfAssessmentWizardQuestionProgress } from './SelfAssessmentWizardQuestionProgress.hooks'

export const SelfAssessmentWizardQuestionProgress = () => {
  const { t } = getTranslate()
  const { questionNumber, questionCount } = useSelfAssessmentWizardQuestionProgress()

  const label = `${t('general.step')} ${questionNumber} / ${questionCount}`

  return (
    <div className="flex flex-col gap-3">
      <Text element="p" variant="sm" weight="bold" className="text-petrol-500">
        {label}
      </Text>

      <Progress
        value={(questionNumber / questionCount) * 100}
        aria-label={label}
        className="bg-sand-600 [&>div]:bg-petrol-500"
      />
    </div>
  )
}
